<template>
    <div class="container-reclef">
        <TopoSlot></TopoSlot>
        <h3 style="text-align: center; margin: 45px 0px 20px;font-weight: 600;color: rgb(112, 112, 112);">Minhas consultas</h3> 
        <table class="consulta__tabela">
            <thead>
                <tr>
                    <td>
                        Data
                    </td>
                    <td>
                        Tipo de Documento
                    </td>
                    <td>    
                        CNPJ
                    </td>
                    <td style="padding:10px 25px;">
                        Ação
                    </td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(n,i) in notas" :key="i">
                    <td>{{n.dataConsulta}}</td>
                    <td>{{n.tipoDocumento}}</td>
                    <td>{{n.cnpj}}</td>
                    <td>                        
                        <b-dropdown   variant="link" toggle-class="text-decoration-none"  >
                            <template #button-content>
                            <img src="/reclef/serach.svg" alt="" width="35px">
                            </template>
                            <b-dropdown-item href="#" style="font-size:14px"  @click="visualizar(n.caminhoConsulta,n.tipoDocumento)">Visualizar</b-dropdown-item>
                            <b-dropdown-item href="#" style="font-size:14px" @click="remover(n.idConsulta)">Remover</b-dropdown-item>                       
                    </b-dropdown>
                    </td>                        
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import config from '../services/config'
export default {
    data(){
        return{
            notas:[]
        }
    },
    methods:{
        async remover(idConsulta){
            let result = await config.remover(idConsulta)
             if(result.status <=205){
                this.Consulta()          
            } 
        },
        async visualizar(caminhoConsulta,tipoDocumento){
            this.$store.state.tipoDocumento = tipoDocumento == 'NF-e e NFC-e' ? 1 : 0
            let result = await config.visualizar(caminhoConsulta)
            console.log(result)         
            if(result.status <=205){
                this.$store.state.resultado = result.data
                this.$router.push({name:'resultado'})
            }  
        },
        async Consulta(){
            
            let result = await config.getConsulta(this.$store.state.idCliente)         
            if(result.status <=205){
                this.notas = result.data           
            }  
        }
    },
    mounted(){
        
        this.Consulta()
    }
}
</script>

<style>
ul.dropdown-menu{
    min-width:5.5rem !important;
}
.consulta__tabela thead, .consulta__tabela thead tr {
    background: #af3437;
    width: 100px!important;
}
.dropdown-toggle::after{
    display: none;
}
.consulta__tabela thead {
    color: #fff;
    font-weight: 700;
     font-size: .8em;
}
.consulta__tabela tbody tr:nth-child(even) {
    background: #ffc5c6;
    
}
.consulta__tabela tbody tr:nth-child(odd) {
    background: #ffffff;
}
.consulta__tabela tbody tr {
    color: #000;
    height: 45px;
    max-height: 50px!important;
     font-size: .78em;
}
.consulta__tabela thead tr td {
    padding: 10px 5px;
    text-align: center;
}
.consulta__tabela tbody tr td {
    padding: 3px 5px;
    text-align: center; 
}
table thead {
    background: red!important;
}
thead {
    display: table-header-group;
}
.consulta__tabela {
    width: 100%;   
    border: 1px solid #af3437;
}
tr {
    background: #af3437;
    width: 100px!important;
}
</style>